import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bootstrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "color-white text-start" }, "LOGO", -1)
const _hoisted_3 = { class: "d-flex flex-wrap gap-4 mt-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "gallery-image-container" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-add color-blue" }, "edit", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-12 color-blue cursor-pointer bold-text montserrat" }, " AGGIUNGI LOGO ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "color-white text-start mt-4" }, "GALLERIA", -1)
const _hoisted_10 = { class: "d-flex flex-wrap gap-4 mt-3" }
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = {
  key: 1,
  class: "color-white background-blue mt-2 cursor-pointer"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-add color-blue" }, "add", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "font-12 color-blue cursor-pointer bold-text montserrat" }, " AGGIUNGI IMMAGINE ", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "modal-content flexbox-column justify-space-between" }
const _hoisted_17 = { class: "top-part flexbox-column align-center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "color-white montserrat insert_pic_text" }, [
  /*#__PURE__*/_createTextVNode(" Ricordati che questa immagine sarà la tua vetrina: scegli una bella immagine che rappresenti al meglio il tuo club."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Perché venga visualizzata correttamente, ti consigliamo di scegliere un'immagine orizzontale, in .jpg o .png e che non pesi più di 10Mb. ")
], -1)
const _hoisted_19 = { class: "flexbox-row" }
const _hoisted_20 = {
  key: 0,
  class: "pic-error"
}
const _hoisted_21 = { class: "buttons-container flexbox-row justify-space-between" }
const _hoisted_22 = { class: "flexbox-row" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "modal-content flexbox-column justify-space-between" }, [
  /*#__PURE__*/_createVNode("div", { class: "top-part flexbox-column align-center" }, [
    /*#__PURE__*/_createVNode("i", { class: "material-icons icon-alert" }, "warning_amber"),
    /*#__PURE__*/_createVNode("p", { class: "color-white montserrat insert_pic_text" }, " Sei sicuro di voler eliminare questa immagine? ")
  ])
], -1)
const _hoisted_25 = { class: "buttons-container flexbox-row justify-space-between" }
const _hoisted_26 = { class: "flexbox-row" }

import { ToastErrors } from "@/constants/generic-errors.enum";
import { ClubPicture } from "@/generated-sources/gestioneclub-api";
import { showToast } from "@/services/error-management.service";
import { uppercase } from "@/services/mapping.service";
import { ActionTypes } from "@/store/action-types";
import { MutationTypes } from "@/store/mutation-types";
import { useStore } from "@/store/store";
import { DataURL } from "@/utils/custom-types";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";


export default _defineComponent({
  setup(__props) {

const DEFAULT = {
  // IMAGES_ASPECT_RATIO: 4 / 3,
  // IMAGES_MIN_HRESOLUTION: 800,
  // LOGO_ASPECT_RATIO: 1,
  // LOGO_MIN_HRESOLUTION: 2000,
  ASPECT_RATIO_TOLERANCE: 0.05, // Allowable difference in aspect ratio
};

const { t } = useI18n();
const store = useStore();
const clubId = computed(() => store.getters.getMyClub.club_id);
const images = ref<ClubPicture[]>([]);
const logoURL = ref<string>(null);
const modalToShow = ref<"UPDATE_PICTURE" | "UPDATE_LOGO" | "DELETE">(null);
const temporaryPic = ref<DataURL>(null);
const imageIdToDelete = ref<string>(null);
const picError = ref<string | null>(null);
const padelUploadRef = ref(null);

onMounted(async () => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  await _load();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  await _loadGlobalSettings();
});

async function _loadGlobalSettings() {
  const settings = await store.dispatch(ActionTypes.GET_GLOBAL_SETTINGS, null);
  store.commit(MutationTypes.SET_GLOBAL_SETTINGS, settings);
}

const openUpdatePPicModal = () => {
  modalToShow.value = "UPDATE_PICTURE";
  picError.value = null;
  temporaryPic.value = null;
};

const openUpdateLogoModal = () => {
  modalToShow.value = "UPDATE_LOGO";
  picError.value = null;
  temporaryPic.value = null;
};

function hideModal() {
  modalToShow.value = null;
}

function temporaryUploader(event: DataURL) {
  const imagesAspectRatio = store.getters.getGlobalSettings.images_aspect_ratio;
  const imagesMinHResolution =
    store.getters.getGlobalSettings.images_min_horizontal_resolution;
  const logoAspectRatio = store.getters.getGlobalSettings.logo_aspect_ratio;
  const logoMinHResolution =
    store.getters.getGlobalSettings.logo_min_horizontal_resolution;

  picError.value = null;

  temporaryPic.value = event;
  // Check if the picture aspect ratio is 4:3
  if (event && event.src) {
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      const targetRatio =
        modalToShow.value === "UPDATE_PICTURE"
          ? imagesAspectRatio
          : logoAspectRatio;

      // Check horizontal resolution
      const minResolution =
        modalToShow.value === "UPDATE_PICTURE"
          ? imagesMinHResolution
          : logoMinHResolution;

      console.log(
        `Aspect Ratio: ${aspectRatio}, Target Ratio: ${targetRatio}, Min Resolution: ${minResolution}`
      );

      if (minResolution != null && img.width < minResolution) {
        picError.value = `${ToastErrors.WRONG_RESOLUTION} (${minResolution}px)`;
        temporaryPic.value = null;
        if (padelUploadRef.value) {
          padelUploadRef.value.resetFileUpload();
        }
        return;
      }

      if (
        targetRatio != null &&
        Math.abs(aspectRatio - targetRatio) > DEFAULT.ASPECT_RATIO_TOLERANCE
      ) {
        picError.value = `${ToastErrors.WRONG_ASPECT_RATIO} (larghezza/altezza=${targetRatio})`;
        temporaryPic.value = null;
        if (padelUploadRef.value) {
          padelUploadRef.value.resetFileUpload();
        }
      }
    };
    img.src = event.src;
  }
}

function handleWrongFileUploaded(file) {
  showToast(ToastErrors.WRONG_FILE_FORMAT);
}

async function updatePhoto() {
  if (temporaryPic.value) {
    try {
      await store.dispatch(ActionTypes.UPDATE_CLUB_PICTURE, {
        clubId: clubId.value,
        base64: temporaryPic.value.src,
        isMain: false,
      });
      hideModal();
      temporaryPic.value = null;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      _load();
    } catch (error) {
      showToast(ToastErrors.UPDATE_CLUB_PICTURE);
      console.error(error);
    }
  }
}
async function updateLogo() {
  if (temporaryPic.value) {
    try {
      await store.dispatch(ActionTypes.UPDATE_CLUB_LOGO, {
        clubId: clubId.value,
        base64: temporaryPic.value.src,
      });
      hideModal();
      temporaryPic.value = null;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      _load();
    } catch (error) {
      showToast(ToastErrors.UPDATE_CLUB_LOGO);
      console.error(error);
    }
  }
}

function deleteImage(id: string) {
  imageIdToDelete.value = id;
  modalToShow.value = "DELETE";
}
async function setMain(id: string) {
  try {
    await store.dispatch(ActionTypes.SET_MAIN_CLUB_PICTURE, {
      clubId: clubId.value,
      pictureId: id,
    });
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    _load();
  } catch (error) {
    showToast(ToastErrors.SET_MAIN_CLUB_PICTURE);
    console.error(error);
  }
}

async function confirmDelete() {
  try {
    await store.dispatch(ActionTypes.DELETE_CLUB_PICTURE, {
      clubId: clubId.value,
      pictureId: imageIdToDelete.value,
    });
    hideModal();
    imageIdToDelete.value = null;
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    _load();
  } catch (error) {
    showToast(ToastErrors.DELETE_CLUB_PICTURE);
    console.error(error);
  }
}

async function _load() {
  images.value = await store.dispatch(ActionTypes.GET_CLUB_PICTURES, {
    clubId: clubId.value,
  });
  logoURL.value = await store.dispatch(ActionTypes.GET_CLUB_LOGO, {
    clubId: clubId.value,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_PadelUpload = _resolveComponent("PadelUpload")!
  const _component_PadelButton = _resolveComponent("PadelButton")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        (logoURL.value)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("i", {
                    class: "material-icons icon-edit color-blue position-absolute",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (openUpdateLogoModal()))
                  }, "edit"),
                  _createVNode("img", {
                    src: logoURL.value,
                    class: "gallery-image"
                  }, null, 8, ["src"])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "box-gallery justify-center",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openUpdateLogoModal()))
            }, [
              _hoisted_7,
              _hoisted_8
            ]))
      ]),
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(images.value, (image) => {
          return (_openBlock(), _createBlock("div", {
            key: image.id
          }, [
            _createVNode("div", {
              class: ["gallery-image-container", { 'main-picture': image.is_main }]
            }, [
              _createVNode("div", _hoisted_11, [
                (!image.is_main)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "material-icons icon-delete color-blue position-absolute",
                      onClick: ($event: any) => (deleteImage(image.id))
                    }, "cancel", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode("img", {
                  src: image.url,
                  class: "gallery-image"
                }, null, 8, ["src"])
              ])
            ], 2),
            (!image.is_main)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "color-blue mt-2 cursor-pointer",
                  onClick: ($event: any) => (setMain(image.id))
                }, " IMPOSTA COME PRINCIPALE ", 8, ["onClick"]))
              : (_openBlock(), _createBlock("div", _hoisted_12, " IMMAGINE PRINCIPALE "))
          ]))
        }), 128)),
        _createVNode("div", {
          class: "box-gallery justify-center",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (openUpdatePPicModal()))
        }, [
          _hoisted_13,
          _hoisted_14
        ])
      ])
    ]),
    (modalToShow.value === 'UPDATE_PICTURE' || modalToShow.value === 'UPDATE_LOGO')
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode(_component_DumbModal, {
            title: _unref(t)('insert_club_picture'),
            onHide: _cache[8] || (_cache[8] = ($event: any) => (hideModal()))
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_PadelUpload, {
                      ref: padelUploadRef,
                      label: _unref(uppercase)(_unref(t)('add_picture')),
                      icon: 'add_a_photo',
                      uploadedLabel: _unref(uppercase)(_unref(t)('picture_added')),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (temporaryUploader($event))),
                      onWrongFileUploaded: _cache[5] || (_cache[5] = ($event: any) => (handleWrongFileUploaded($event)))
                    }, null, 8, ["label", "uploadedLabel"])
                  ]),
                  (picError.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, "ERRORE: " + _toDisplayString(picError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("p", {
                  class: "abort cursor-pointer",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (hideModal()))
                }, _toDisplayString(_unref(uppercase)(_unref(t)("close"))), 1),
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_PadelButton, {
                    label: _unref(uppercase)(_unref(t)('load')),
                    disabled: !temporaryPic.value,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (
              modalToShow.value === 'UPDATE_PICTURE' ? updatePhoto() : updateLogo()
            ))
                  }, null, 8, ["label", "disabled"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : (modalToShow.value === 'DELETE')
        ? (_openBlock(), _createBlock("div", _hoisted_23, [
            _createVNode(_component_DumbModal, {
              title: 'Eliminazione immagine',
              onHide: _cache[11] || (_cache[11] = ($event: any) => (hideModal()))
            }, {
              default: _withCtx(() => [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _createVNode("p", {
                    class: "abort cursor-pointer",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (hideModal()))
                  }, _toDisplayString(_unref(uppercase)(_unref(t)("abort"))), 1),
                  _createVNode("div", _hoisted_26, [
                    _createVNode(_component_PadelButton, {
                      label: _unref(uppercase)(_unref(t)('confirm')),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmDelete()))
                    }, null, 8, ["label"])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
  ], 64))
}
}

})